import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { FloatingSparkles } from './FloatingSparkles';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-cream" data-id="element-170">
      <FloatingSparkles count={30} color="#D4849A" data-id="element-171" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,132,154,0.15)_0%,transparent_50%)] pointer-events-none" data-id="element-172"></div>
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-173">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-174">
          <motion.div className="flex-1 text-center lg:text-left z-10" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-175">
            <div className="inline-flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6" data-id="element-176">
              <div className="flex text-rosegold" data-id="element-177">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-178" />)}
              </div>
              <span className="text-xs font-medium text-taupe uppercase tracking-wider" data-id="element-179">
                + 2,500 mujeres ya transformaron su vida
              </span>
            </div>

            <h1 className="md:text-5xl lg:text-6xl font-serif text-burgundy mb-6 text-[32px] relative inline-block" data-id="element-180">
              <motion.span className="absolute -top-6 -left-6 text-rosegold text-2xl" animate={{
              rotate: [0, 15, -15, 0],
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 3,
              repeat: Infinity
            }} data-id="element-181">
                ✦
              </motion.span>
              Deja de buscar afuera lo que{' '}
              <span className="italic text-rosegold relative" data-id="element-182">
                ya vive en ti
                <motion.span className="absolute -top-4 -right-8 text-rosegold text-xl" animate={{
                rotate: [0, -15, 15, 0],
                scale: [1, 1.3, 1]
              }} transition={{
                duration: 2.5,
                repeat: Infinity,
                delay: 0.5
              }} data-id="element-183">
                  ✦
                </motion.span>
              </span>
            </h1>

            <p className="text-lg md:text-xl text-taupe mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-184">
              El Método Coherencia Femenina te enseña a regular tu energía,
              alinear tu identidad y sostener acciones reales para crear la vida
              que mereces.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-185">
              <a href="#pricing" className="shimmer-btn w-full sm:w-auto bg-rosegold text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-rosegold/90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-186">
                Sí, quiero acceder al método
              </a>
            </div>
          </motion.div>

          <motion.div className="flex-1 relative z-10 w-full max-w-lg lg:max-w-none mx-auto" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-187">
            <div className="relative" data-id="element-188">
              {/* Decorative background glow */}
              <div className="absolute inset-0 bg-rosegold/30 blur-[80px] rounded-full transform scale-110 animate-pulse" data-id="element-189"></div>
              <img src="https://cdn.magicpatterns.com/uploads/27B9cTx8Rrpd3ZDv5JNzpB/Metodo_Coherencia_Femenina_y_libros_guia.png" alt="Método Coherencia Femenina Libros" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-190" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}